export default "__VITE_ASSET__BX1N_qP8__"